const InputNumber = ({ parameter, handleInputNumber, classNameStyle }) => {
    return (
        <input
            type='number'
            step='any'
            id='serial-number-input'
            className={classNameStyle}
            value={parameter}
            onChange={handleInputNumber}
        />
    );
};

export default InputNumber;